import React from 'react';
import { BreadCrumb } from "primereact/breadcrumb";
import { Navigate, useLocation } from 'react-router-dom';
import { breadcrumb } from './SideBarLayout/Breadcrumb';

const AppBreadcrumb = () => {
    const location = useLocation();

    const meta = breadcrumb.find((obj) => {
        return obj.path === location.pathname;
    });

    if (typeof meta === "undefined"){
        return <Navigate to='/asset' />
    }
    
    const model = [{ label: meta.parent }, { label: meta.label, url: meta.path }]
    const home = { icon: "pi pi-home", url: "/asset" }

    return (
        <div className="layout-breadcrumb-container">
            <BreadCrumb model={model} home={home} className="layout-breadcrumb" />
        </div>
    )
};

export default AppBreadcrumb;
